module.exports = __webpack_public_path__ + "img/x-icon.4e1c021f.svg";